import { css } from 'src/styles/theme';

export const StyledAC = css``;
